<div [ngClass]="['copyright', styleClass]">
  My Hivve v.{{currentVersion}} &copy; {{currentYear}}
  <a rel="noopener" href="https://hivve.tech" target="_blank">HIVVE GROUP LTD.</a>
  &nbsp;
</div>
